var exports = {
  "Y": "IntroSection__LRa3Yv",
};

module.exports = exports;
